import React, { Component } from 'react';

import MainArea from './components/MainArea';
import NavigationBar from './components/NavigationBar';
import Sidebar from 'react-sidebar';   

import {
  Input,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Container
} from 'reactstrap';

import {MONSTERS} from './lib/monsters/index';
import {SCENARIO_DEFINITIONS} from './lib/scenarioList';
// console.log(SCENARIO_DEFINITIONS);


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: false,
      scenarioLevel:0,
      scenarioNumber:1,
      scenarioLevelValue:0,
      scenarioNumberValue:1,
      scenarioName:"",
      scenarioLoaded:false,
      scenarioMonsterObjs:[],


      // sidebar
      scenarioNumberValid: true,
      monsterList: Object.keys(MONSTERS),
      selectedMonster: "",
      selectedMonsterLevel: 0
    }

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.setScenarioLevel = this.setScenarioLevel.bind(this);
    this.setScenarioNumber = this.setScenarioNumber.bind(this);
    this.loadScenario = this.loadScenario.bind(this);
    this.addMonster = this.addMonster.bind(this);
    this.removeMonster = this.removeMonster.bind(this);

    // sidebar
    this.handleScenarioLevelChange = this.handleScenarioLevelChange.bind(this);
    this.handleScenarioNumberChange = this.handleScenarioNumberChange.bind(this);
    this.handleMonsterSelectChange = this.handleMonsterSelectChange.bind(this);
    this.handleSelectMonsterLevelChange = this.handleSelectMonsterLevelChange.bind(this);
  }

  //sidebar
  onSetSidebarOpen = (open) => {
    this.setState({sidebarOpen: open});
  }

  toggleSidebar = () => {
    this.setState({sidebarOpen:!this.state.sidebarOpen});
  }

  setScenarioLevel = (level) => {
    this.setState({scenarioLevelValue:level});
  }

  setScenarioNumber = (scenarioNumber) => {
    this.setState({scenarioNumberValue:scenarioNumber});
  }

  handleScenarioLevelChange(event) {
    this.setState({ scenarioLevelValue: event.target.value });
    this.setScenarioLevel(event.target.value);
  }

  handleScenarioNumberChange(event) {
    if (event.target.value >= 1 && event.target.value <= 95) {
      this.setState({ scenarioNumberValue: event.target.value, scenarioNumberValid: true });
      this.setScenarioNumber(event.target.value);
    } else {
      this.setState({ scenarioNumberValid: false })
    }
  }

  handleMonsterSelectChange(event) {
    this.setState({ selectedMonster: event.target.value });
  }

  handleSelectMonsterLevelChange(event) {
    this.setState({ selectedMonsterLevel: event.target.value });
  }



  loadScenario = () => {
    this.setState({scenarioLevel:this.state.scenarioLevelValue, scenarioMonsterObjs:[]},() => {
      const scenarioEntry = SCENARIO_DEFINITIONS[this.state.scenarioNumberValue - 1];
      // console.log(scenarioEntry);
      const scenarioName = scenarioEntry.name;
      const scenarioMonsters = scenarioEntry.decks.map((deckItem) => {
        return (deckItem.name);
      });
      console.log("scenario name: " + scenarioName);
      console.log("scenario monsters: " + scenarioMonsters);

      let newScenarioMonsterObj = [];
      scenarioMonsters.map((monster) => {
        newScenarioMonsterObj.push({
          monsterType: monster,
          monsterLevel: this.state.scenarioLevel
        });
        return null;
      });
      this.setState({
        scenarioMonsterObjs: newScenarioMonsterObj,
        scenarioLoaded: true,
        scenarioName: scenarioName
      });
    })
    
  }

  addMonster = (monster, level = this.state.scenarioLevel) => {
    let index = this.state.scenarioMonsterObjs.findIndex((monsterelement) => {
      return monsterelement.monsterType === monster;
    })

    if(this.state.scenarioLoaded === false) {
      this.setState({scenarioLoaded:true});
    }

    //if new monster, add
    if(index === -1){
      let newScenarioMonsterObj = {
        monsterType: monster,
        monsterLevel: level
      }

      this.setState({ scenarioMonsterObjs: [...this.state.scenarioMonsterObjs, newScenarioMonsterObj] });
      console.log("added monster");
    } else {
      let index = this.state.scenarioMonsterObjs.findIndex((monsterelement) => {
        return monsterelement.monsterType === monster;
      });

      let newScenarioMonsterObjs = this.state.scenarioMonsterObjs;
      newScenarioMonsterObjs.splice(index, 1);
      
      this.setState({ scenarioMonsterObjs: newScenarioMonsterObjs },() => {
        let newScenarioMonsterObjs2 = this.state.scenarioMonsterObjs;
        newScenarioMonsterObjs2.push( {
          monsterType: monster,
          monsterLevel: level
        })
        this.setState({ scenarioMonsterObjs: newScenarioMonsterObjs2 });
        console.log("updated monster level");
      });

      
    }
  }

  removeMonster = (monster) => {
    let index = this.state.scenarioMonsterObjs.findIndex((monsterelement) => {
      return monsterelement.monsterType === monster;
    });

    let newScenarioMonsterObjs = this.state.scenarioMonsterObjs;
    newScenarioMonsterObjs.splice(index,1);
    this.setState({scenarioMonsterObjs: newScenarioMonsterObjs});
    console.log("removed monster");

  }


  render() {


    const sidebarContent =

      <div>
        <Container style={{ backgroundColor: "#FFFFFF", height: "100%", minHeight: "100vh", paddingTop:"20px" }}>

          <h2 style={{ fontFamily: "PirataOne" }}>Options</h2>
          <br />

          <FormGroup>
            <Label for="scenarioNumberInput" style={{ fontFamily: "HighTower" }}>Scenario Number</Label>
            <Input
              placeholder="Scenario Number" id="scenarioNumberInput"
              type="number"
              onChange={this.handleScenarioNumberChange}
              valid={this.state.scenarioNumberValid}
            />
            {this.state.scenarioNumberValid === false ? <FormFeedback>Invalid Scenario Number</FormFeedback> : null}
            <br />
            <Label for="scenarioLevelInput" style={{ fontFamily: "HighTower" }}>Scenario Level</Label>
            <Input id="scenarioLevelInput"
              type="select"
              defaultValue="0"
              onChange={this.handleScenarioLevelChange}>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((number) => {
                return (
                  <option key={number} value={number}>{number}</option>
                )
              })}
            </Input>
            <br />
            <Button
              color="primary"
              size="medium"
              onClick={this.loadScenario}
            >
              Load Scenario
          </Button>
          </FormGroup>


          <br />
          <hr />
          <br />
          <h2 style={{ fontFamily: "PirataOne" }}>Add Monster</h2>
          <br />
          <FormGroup>
            <Label for="selectMonster" style={{ fontFamily: "HighTower" }}>Select Monster</Label>
            <Input type="select" id="selectMonster" onChange={this.handleMonsterSelectChange} defaultValue="">
              <option value="" disabled>Monster Type</option>
              {this.state.monsterList.map((monster) => {
                return (
                  <option key={monster} value={monster}>{monster}</option>
                )
              })}
            </Input>

          </FormGroup>
          <Form inline>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Label for="selectMonsterLevel" style={{ fontFamily: "PirataOne" }} className="mr-sm-2">Monster Level: </Label>
              <Input type="select" id="selectMonsterLevel" onChange={this.handleSelectMonsterLevelChange} defaultValue={this.state.scenarioLevelValue}>
                {[0, 1, 2, 3, 4, 5, 6, 7].map((number) => {
                  return (
                    <option key={number} value={number}>{number}</option>
                  )
                })}
              </Input>
            </FormGroup>
          </Form>
          <br />
          <Button color="primary" size="medium" onClick={() => { this.addMonster(this.state.selectedMonster, this.state.selectedMonsterLevel) }}>
            Add Monster
            </Button>


        </Container>
      </div>
      ;




    return (
      <div>

        <Sidebar sidebar={sidebarContent}
          open={this.state.sidebarOpen}
          onSetOpen={this.onSetSidebarOpen}
          children=""
          style={{ padding: "5px" }}
        >

      
        <NavigationBar 
          toggleSidebar={this.toggleSidebar}
          scenarioLoaded={this.state.scenarioLoaded}
          scenarioLevel={this.state.scenarioLevel}
          scenarioNumber={this.state.scenarioNumber}
          scenarioName={this.state.scenarioName}
          />
        <MainArea
          toggleSidebar={this.toggleSidebar} 
          scenarioLoaded={this.state.scenarioLoaded}
          scenarioLevel={this.state.scenarioLevel}
          scenarioNumber={this.state.scenarioNumber}
          scenarioName={this.state.scenarioName}
          monstersObjList={this.state.scenarioMonsterObjs}
          removeMonster={this.removeMonster}
          />
        </Sidebar>  
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js